import { render, staticRenderFns } from "./SpecieAdd.vue?vue&type=template&id=47a07839&scoped=true&"
import script from "./SpecieAdd.vue?vue&type=script&lang=js&"
export * from "./SpecieAdd.vue?vue&type=script&lang=js&"
import style0 from "./SpecieAdd.vue?vue&type=style&index=0&id=47a07839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a07839",
  null
  
)

export default component.exports